import { render, staticRenderFns } from "./SignerListForMessaging.vue?vue&type=template&id=2690f4c6&"
import script from "./SignerListForMessaging.vue?vue&type=script&lang=js&"
export * from "./SignerListForMessaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports